import HWY_Accordion from "./accordion";
import HWY_CountDown from "./countdown";
import HWY_Slider from "./slider";
import HWY_HeroVideo from "./hero-video";
import HWY_Media from "./media";
import HWY_Header from "./header";
import HWY_Filter from "./filter";
import HWY_History from "./history";
import HWY_TradeMedia from "./trade-media";
import HWY_Events from "./events";
import HWY_Carousel from "./carousel";
import HWY_SliderTestimonial from "./testimonial";
import HWY_Scroll from "./scroll";
import HWY_Article from "./article";
import HWY_Step from "./fellowship-step";
import HWY_GiftSet from "./gift-set-builder";
import HWY_Etched from "./etched";

export default function Modules() {
  this.init = () => {
    new HWY_Accordion().init();
    new HWY_CountDown().init();
    new HWY_Slider().init();
    new HWY_HeroVideo().init();
    new HWY_Media().init();
    new HWY_Header().init();
    new HWY_Filter().init();
    new HWY_History().init();
    new HWY_TradeMedia().init();
    new HWY_Events().init();
    new HWY_Carousel().init();
    new HWY_SliderTestimonial().init();
    new HWY_Scroll().init();
    new HWY_Article().init();
    new HWY_Step().init();
    new HWY_GiftSet().init();
    new HWY_Etched().init();
  };
}
